export default __webpack_public_path__ + "static/media/pineapple.1ce965c1.png";